enum Currency {
  ruble = '\u00A0\u20bd',
  dash = '\u2013',
}

export default Currency;
